/** Výška sady workflow */
export const WIDTH_OF_WF_SET = 6000;
/** Šířka sady workflow */
export const HEIGHT_OF_WF_SET = 3300;
/** Defaultní x-ová hodnota pozice aktivity na sadě */
export const DEFAULT_ACTIVITY_LEFT = 10;
/** Defaultní y-ová hodnota pozice aktivity na sadě */
export const DEFAULT_ACTIVITY_TOP = 10;
